import React from 'react';
import './Category.scss';

const Category = props => {
  const {category, iconsUrl} = props;

  let userScoreClass = 'summary__category__score__user--success';
  if (category.score < (category.total / 2)) {
    userScoreClass = 'summary__category__score__user--failure';
  }

  return (
    <div className='summary__category'>
      <div className='summary__category__icon'>
        <img src={iconsUrl + '/icone_cat_' + category.code + '.svg'} alt={category.name}/>
      </div>
      <div className='summary__category__body'>
        <div className='summary__category__name'>{category.name}</div>
        <div className='summary__category__score'>
          <span className={'summary__category__score__user ' + userScoreClass}>{category.score}</span>
          /
          <span className='summary__category__score__max'>{category.total}</span>
        </div>
      </div>
    </div>
  );
};

export default Category;
